import { render, staticRenderFns } from "./reisetermin-card-vorgaenge.vue?vue&type=template&id=f21b93de"
import script from "./reisetermin-card-vorgaenge.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports